import { supabase } from '@/integrations/supabase/client';

/** Events the server records for a Your Next Move™ card. Done/Not now goes through dismiss instead. */
export type NextMoveEvent = 'shown' | 'skipped' | 'clicked';

/** How long an action button waits for the click record before navigating anyway. */
export const CLICK_RECORD_TIMEOUT_MS = 400;

/**
 * The only client writer of Your Next Move™ events. The server stamps persona, rule side and
 * priority, so every surface reports the same thing. Errors are logged, never swallowed silently.
 */
export async function recordNextMoveEvent(ruleKey: string, event: NextMoveEvent, surface: string, priority?: number): Promise<void> {
  try {
    const res = await supabase.rpc('record_desk_next_move_event' as never, {
      p_rule_key: ruleKey, p_event: event, p_surface: surface, p_priority: priority ?? null,
    } as never);
    if (res?.error) console.warn(`[next-move] ${event} not recorded for ${ruleKey}:`, res.error.message);
  } catch (e) {
    console.warn(`[next-move] ${event} not recorded for ${ruleKey}:`, e);
  }
}

/** Record the click first (bounded wait), so navigation can never cancel it. */
export function recordClickBeforeNavigate(ruleKey: string, surface: string, timeoutMs = CLICK_RECORD_TIMEOUT_MS): Promise<void> {
  return Promise.race([
    recordNextMoveEvent(ruleKey, 'clicked', surface),
    new Promise<void>((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
}
